import ContactEmail, {
  IContactEmail,
  IContactEmailApiModel,
} from './ContactEmail.model';
import ContactPhone, {
  IContactPhone,
  IContactPhoneApiModel,
} from './ContactPhone.model';

export interface IContact {
  id: string;
  name?: string;
  title: string;
  ownerStudioId?: string;
  phone?: string;
  email?: string;
  website?: string;
  isGlobal: boolean;
  phones: IContactPhone[];
  emails: IContactEmail[];
  favorite: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface IContactApiModel {
  id: string;
  title: string;
  name: string;
  ownerStudioId?: string;
  phone: string;
  email: string;
  website: string;
  isGlobal?: boolean;
  phones?: IContactPhoneApiModel[];
  emails?: IContactEmailApiModel[];
  studioContacts?: Array<{ favorite: boolean }>;
  createdAt: string;
  updatedAt: string;
}

export default class Contact implements IContact {
  public readonly id: string;

  public readonly name: string;

  public readonly title: string;

  public readonly favorite: boolean;

  public readonly ownerStudioId?: string;

  public readonly phone: string;

  public readonly email: string;

  public readonly website: string;

  public readonly isGlobal: boolean;

  public readonly phones: IContactPhone[];

  public readonly emails: IContactEmail[];

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    name: string,
    title: string,
    phone: string,
    email: string,
    website: string,
    favorite: boolean,
    isGlobal: boolean,
    phones: IContactPhone[],
    emails: IContactEmail[],
    createdAt: Date,
    updatedAt: Date,
    ownerStudioId?: string,
  ) {
    this.id = id;
    this.name = name;
    this.title = title;
    this.phone = phone;
    this.email = email;
    this.website = website;
    this.isGlobal = isGlobal;
    this.phones = phones;
    this.favorite = favorite;
    this.emails = emails;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.ownerStudioId = ownerStudioId;
  }

  static fromApiModel(apiModel: IContactApiModel) {
    const {
      id,
      name,
      title,
      phone,
      email,
      website,
      isGlobal,
      ownerStudioId,
      studioContacts,
    } = apiModel;

    const favorite = studioContacts?.[0]?.favorite || false;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    const phones = apiModel.phones
      ? ContactPhone.arrayFromApiModel(apiModel.phones)
      : [];
    const emails = apiModel.emails
      ? ContactEmail.arrayFromApiModel(apiModel.emails)
      : [];

    return new Contact(
      id,
      name,
      title,
      phone,
      email,
      website,
      favorite,
      !!isGlobal,
      phones,
      emails,
      createdAt,
      updatedAt,
      ownerStudioId,
    );
  }

  static arrayFromApiModel(arrayApiModel: IContactApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
